/* eslint-disable no-unused-vars */
import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getLink } from '../../api/getLink';
import { useAppSelector } from '../../app/hooks';
import { RootState } from '../../app/store';
import { useBffQueryApi } from '../../hooks/useQueryBffApi';
import { ONECARD, ONESCORE } from '../../constants/constants';
import { useWindowWidth } from '../../hooks/useWindowWidth';
import AppleAppStore from '../../images/Apple.svg';
import AndroidStore from '../../images/PlayStore.svg';
import { DESKTOP, MOBILE } from '../Common/Placeholder';
import { deviceDetect } from '../Common/DeviceDetect';
import { PopupContext } from '../Common/Custompopups';
import { MODAL, TOAST } from '../Common/ConstantStrings';

interface Igetlink {
  apptype: string;
  textContent?: string;
}

export const GetLink = (props: Igetlink) => {
  const { apptype, textContent } = props;
  const [isButtonClicked, setIsButtonClicked] = useState(false);
  const navigate = useNavigate();
  const popupContext = useContext(PopupContext);
  const authzToken = useAppSelector(
    (state: RootState) => state.authz.AuthzInfo,
  );
  const {
    data: response,
    error,
    isLoading,
    refetch,
  } = useBffQueryApi<any, any>(
    'getLink',
    () => getLink({ auth: authzToken, apptype }),
    false,
    true,
    (response) => {
      if (response.status === 200) {
        setIsButtonClicked(true);
      }
    },
    (error) => {
      if (error.response?.status === 500) {
        navigate('/onecardweb/error');
      }

      if (error.response?.status === 401) {
        // popupContext.showPopup('Please Login Again', MODAL);
        navigate('/onecardweb/phone');
      }
    },
  );
  // if (error?.response?.status === 401) {
  //   alert('Session Expired please Login');
  //   popupContext.showPopup('Please try again later', TOAST);
  //   clearUserSession();
  //   // navigate('/onecardweb/phone');
  // }
  const getLinkToApp = () => {
    if (deviceDetect() === DESKTOP) {
      refetch();
    } else {
      if (navigator.userAgent.includes('Android')) {
        if (apptype === ONECARD) {
          window.open('https://bit.ly/WebOneCard');
        }
        if (apptype === ONESCORE) {
          window.open('http://bit.ly/3GNf1jd');
        }
      }
      if (navigator.userAgent.includes('iPhone')) {
        if (apptype === ONECARD) {
          window.open('https://bit.ly/WebOneCard');
        }
        if (apptype === ONESCORE) {
          window.open('http://bit.ly/3GNf1jd');
        }
      }
    }
  };
  const StoreImage = navigator.userAgent.includes('Android')
    ? AndroidStore
    : AppleAppStore;
  const dimention = useWindowWidth();
  return dimention.width <= 640 ? (
    <div className="w-auto">
      <button
        type="button"
        onClick={() => {
          getLinkToApp();
        }}
        className="h-10 md:h-12  w-auto sm:w-32 bg-confirmbtn-500 rounded-xl  text-xl  flex items-center justify-center px-2"
      >
        <span className=" w-auto flex justify-center items-center">
          {textContent || 'Activate Now'}
        </span>
        <img src={StoreImage} alt="Apple" className="w-5 h-5 ml-1" />
      </button>
    </div>
  ) : (
    <div className="w-full">
      <button
        type="button"
        onClick={() => {
          getLinkToApp();
        }}
        className={`h-10 md:h-12 w-32 md:w-full ${
          isButtonClicked
            ? 'bg-successgress-100'
            : 'bg-confirmbtn-500'
        }  rounded-xl  text-xl  flex items-center justify-center`}
      >
        {isLoading ? (
          <span className="animate-spin rounded-full h-5 w-5 border-l-2 border-white inline mr-2">
            {' '}
          </span>
        ) : (
          <span className=" w-auto   flex justify-center items-center">
            {isButtonClicked ? 'Link Sent' : 'Get Link'}
            {isButtonClicked ? (
              <img
                alt="check mark"
                src="https://www.getonecard.app/assets/apply/check.svg"
                className="md:h-5 md:w-5 ml-1 md:ml-3 h-4 w-4"
              />
            ) : (
              ''
            )}
          </span>
        )}
      </button>
      {isLoading ? <h2 className="hidden">Link Sent</h2> : null}
      {response && response.status === 200 ? (
        <h2 className="hidden">Success!!</h2>
      ) : null}
      {error ? <h2 className="hidden">{error.message}</h2> : null}
    </div>
  );
};
